import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useAuth } from '../aws/AuthContext';

const API_BASE_URL = process.env.REACT_APP_API_URL;
const API_URL = `${API_BASE_URL}/v1-sesiones-caja`;

export const useCaja = () => {
    const queryClient = useQueryClient();
    const { getJwtToken } = useAuth();

    // OBTENER ESTADO DE LA CAJA (Consulta si hay una abierta)
    const getCajaActiva = useQuery({
        queryKey: ['caja-activa'],
        queryFn: async () => {
            const token = await getJwtToken();
            const { data } = await axios.get(API_URL, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return data; 
        },
        staleTime: 1000 * 60 * 30, // Considera la data fresca por 30 mins
        refetchOnWindowFocus: false, // Aquí SÍ queremos que consulte si el cajero cambia de pestaña y vuelve
    });

    // ABRIR UNA NUEVA CAJA
    const abrirCaja = useMutation({
        mutationFn: async (payload) => {
            const token = await getJwtToken();
            return axios.post(API_URL, payload, {
                headers: { Authorization: `Bearer ${token}` }
            });
        },
        onSuccess: () => {
            // Cuando se abre la caja con éxito, invalidamos la caché
            queryClient.invalidateQueries(['caja-activa']);
        }
    });

    // (Opcional por ahora) 3. CERRAR CAJA
    const cerrarCaja = useMutation({
        mutationFn: async (payloadCierre) => {
            const token = await getJwtToken();
            // Asumiendo que usarás PUT para cerrar la caja enviando el id de la sesión
            return axios.put(`${API_URL}/${payloadCierre.id}`, payloadCierre, {
                headers: { Authorization: `Bearer ${token}` }
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['caja-activa']);
        }
    });

    return { 
        getCajaActiva, 
        abrirCaja,
        cerrarCaja
    };
};